// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1yMfk","col":"styles_col__2Ur2V"};